import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { Zap } from 'lucide-react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-neon text-black py-3 px-4 shadow-md border-b-2 border-black" data-id="element-480">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 text-center text-sm sm:text-base font-bold" data-id="element-481">
        <div className="flex items-center gap-2" data-id="element-482">
          <Zap className="w-4 h-4 sm:w-5 sm:h-5 fill-black" data-id="element-483" />
          <span data-id="element-484">ATENCIÓN: Esta oferta de lanzamiento expira en</span>
        </div>
        <div className="flex items-center gap-2 bg-black text-neon px-3 py-1 rounded-md" data-id="element-485">
          <CountdownTimer data-id="element-486" />
        </div>
        <span data-id="element-487">— Precio especial solo hoy: 17.99€</span>
      </div>
    </div>;
}